import React from 'react';
import Fade from 'react-reveal/Fade';
import { Row } from 'antd';

const RevealContent = ({ content, showContent = false, styles }) =>
  showContent && (
    <Fade>
      <Row className={styles}>
        <p>{content}</p>
      </Row>
    </Fade>
  );

export default RevealContent;
